var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1407_621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.39552 8.22492L7.89398 8.22492L7.89399 2.74908C7.8909 2.65003 7.90784 2.55137 7.94381 2.45903C7.97977 2.36668 8.03402 2.28255 8.10329 2.21168C8.25332 2.06165 8.4568 1.97737 8.66897 1.97737C8.88115 1.97737 9.08463 2.06165 9.23466 2.21168C9.30533 2.27972 9.36136 2.36148 9.3993 2.45194C9.43723 2.54241 9.45628 2.63968 9.45528 2.73777L9.42699 8.24189L14.9594 8.24189C15.1438 8.23987 15.322 8.30871 15.4572 8.43422C15.6072 8.58425 15.6915 8.78773 15.6915 8.99991C15.6915 9.21208 15.6072 9.41556 15.4572 9.56559C15.3881 9.64068 15.3041 9.70057 15.2106 9.74147C15.1172 9.78237 15.0162 9.80339 14.9141 9.80318L9.44396 9.7749L9.44396 15.262C9.44553 15.3592 9.42785 15.4557 9.39192 15.546C9.356 15.6363 9.30255 15.7186 9.23466 15.7881C9.08463 15.9382 8.88115 16.0224 8.66897 16.0224C8.4568 16.0224 8.25332 15.9382 8.10329 15.7881C8.03262 15.7201 7.97659 15.6383 7.93865 15.5479C7.90072 15.4574 7.88167 15.3601 7.88267 15.262L7.91096 9.75793L2.37855 9.75793C2.19411 9.75995 2.01592 9.6911 1.88075 9.56559C1.73072 9.41556 1.64643 9.21208 1.64643 8.99991C1.64643 8.78773 1.73072 8.58425 1.88075 8.43422C2.01821 8.30016 2.20319 8.22492 2.39552 8.22492Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1407_621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.183716 9) rotate(-45)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus2);
export default __webpack_public_path__ + "static/media/plus-2.16e094f9cfb8c52e972c3fec6dab51ee.svg";
export { ForwardRef as ReactComponent };